/**
 * 活动执行状态
 */
export var ExecActState;
(function (ExecActState) {
    /** 活动执行成功 */
    ExecActState["success"] = "0";
    /** 活动执行失败，内部错误 */
    ExecActState["fail"] = "1";
    /** 不满足领取条件（黑名单） */
    ExecActState["block"] = "2";
    /** 活动库存不足、个人库存不足 */
    ExecActState["stockNotEnough"] = "3";
    /** 用户没有资格（抽奖专用） */
    ExecActState["noQual"] = "4";
    /** 资格已使用（抽奖专用） */
    ExecActState["qualUsed"] = "5";
    /** 资格数量不足（印花专用） */
    ExecActState["qualCountNotEnough"] = "6";
    /** 其他出错情况，内部错误 */
    ExecActState["innerFail"] = "99";
})(ExecActState || (ExecActState = {}));
